import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, Spin, Table } from 'antd';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import BaseListing from 'src/BaseListings';
import { STATUS_NAME } from 'src/models/vouchers';
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper';
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtFormatMoney, wtFormatRoundedValue } from 'src/helpers/commons/utils';
import { wtSubYearsToDate } from 'src/helpers/commons/moment';
import { TYPE_GROUP, TYPE_TOTAL } from 'src/models/pnlConfig';
import { CaretDownFilled, CaretRightFilled, FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons'
import Pdf from './Pdf';

const ProfitAndLossSurcharge = () => {
    const Base = new BaseListing('profit_and_loss')
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm();

    const [projectId, setProjectId] = useState()

    const [voucherStatus, setVoucherStatus] = useState()
    const [voucherStatusName, setVoucherStatusName] = useState('')

    const [branchId, setBranchId] = useState(0)
    const [branchName, setBranchName] = useState('')
    const [profitAndLossSurchargeData, setProfitAndLossSurchargeData] = useState([])
    const [asOf, setAsOf] = useState('')

    const [lastYearLastDate, setLastYearLastDate] = useState(asOf ? wtSubYearsToDate(asOf, 1, "YYYY-MM-DD") : '')

    const companyName = wtGetFromLocalStorage("company_name");

    const [boldRows, setBoldRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);

    // Define columns of trial balance
    const profitAndLossHeaderColumns = [
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Account Description</span>,
            dataIndex: 'name',
            key: 'name',
            align: 'left',
            width: "70%",
            onCell: (record) => ({
                onClick: () => handleExpand(record),
                style: { cursor: 'pointer' }
            }),
            render: (text, record) => (
                <span style={{
                    fontWeight: (record.type === TYPE_TOTAL || boldRows.includes(record.key)) ? 'bold' : 'normal',
                    fontSize: (record.type === TYPE_TOTAL) ? "0.83rem" : "0.8rem",
                    cursor: "pointer"
                }}>
                    {text}
                </span>
            )
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>{"As Of " + asOf}</span>,
            align: 'right',
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Balance ( .Rs. )</span>,
                    dataIndex: 'current_year_balance',
                    key: 'current_year_balance',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.type === TYPE_TOTAL || boldRows.includes(record.key)) ? 'bold' : 'normal',
                            fontSize: (record.type === TYPE_TOTAL) ? "0.83rem" : "0.8rem",
                        }}>
                            {getLink(record, text, 'asof')}
                        </span>
                    ),
                }
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>{"As Of " + lastYearLastDate}</span>,
            align: 'right',
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Balance ( .Rs. )</span>,
                    dataIndex: 'last_year_balance',
                    key: 'last_year_balance',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.type === TYPE_TOTAL || boldRows.includes(record.key)) ? 'bold' : 'normal',
                            fontSize: (record.type === TYPE_TOTAL) ? "0.83rem" : "0.8rem",
                        }}>
                            {getLink(record, text, 'last')}
                        </span>
                    ),
                }
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>%Age</span>,
            dataIndex: 'percentage',
            key: 'percentage',
            align: 'right',
            render: (text, record) => (
                <span style={{
                    fontWeight: (record.type === TYPE_TOTAL || boldRows.includes(record.key)) ? 'bold' : 'normal',
                    fontSize: (record.type === TYPE_TOTAL) ? "0.83rem" : "0.8rem",
                    cursor: "pointer"
                }}>
                    {wtFormatRoundedValue(text, "", true, 2)}
                </span>
            )
        },
    ];


    const getLink = (record, text, key) => {
        if (record.type === TYPE_TOTAL || !record.source_id) {
            return wtFormatMoney(text, "", true, 2);
        }

        let fromDate = "2000-01-01";
        let toDate = "";

        if (key === 'asof') {
            toDate = asOf;
        }

        if (key === 'last') {
            toDate = lastYearLastDate;
        }

        const queryParams = "fromDate=" + fromDate + "&toDate=" + toDate + "&accountId=" + (+record.source_id) + "&voucherStatus=" + (+voucherStatus) + "&branchId=" + (+branchId) + "&branchName=" + branchName + "&projectId=" + (+projectId) + " ";
        return (
            <a href={'/reports?' + queryParams + '#code:account-statement'}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "#000000" }}
            >
                {wtFormatMoney(text, "", true, 2)}
            </a>
        )
    }

    useEffect(() => {
        getQueryParams();
    }, [])

    useEffect(() => {
        if (typeof asOf !== 'undefined' && asOf !== null && asOf !== '') {
            getReportData();
        }
    }, [asOf]);

    const getQueryParams = async () => {

        //get URL
        const url = new URL(window.location.href);

        // Get the search parameters from the URL
        const searchParams = new URLSearchParams(url.search);

        // Get the value of the 'fromDate' parameter
        let asOf = searchParams.get('asOf');
        let lastYearDate = searchParams.get('lastYearLastDate');
        const voucherStatus = searchParams.get('voucherStatus');
        const branchId = searchParams.get('branchId');
        const branchName = searchParams.get('branchName');
        const projectId = searchParams.get('projectId');

        if (asOf !== '' && typeof asOf !== 'undefined' && asOf !== null) {
            setAsOf(asOf)
        }
        if (lastYearDate !== '' && typeof lastYearDate !== 'undefined' && lastYearDate !== null) {
            setLastYearLastDate(lastYearDate);
        }
        if (+voucherStatus > 0) {
            setVoucherStatus(voucherStatus);
            setVoucherStatusName(STATUS_NAME[voucherStatus])
        }
        if (+branchId > 0) {
            setBranchId(branchId);
            setBranchName(branchName);
        }
        if (+projectId > 0) {
            setProjectId(+projectId);
        }
    }

    const getReportData = () => {
        setIsLoading(true);
        wtApiCall(
            'reports/profit_and_loss_surcharge',
            {
                as_of: asOf,
                last_year: lastYearLastDate,
                branch_id: branchId,
                project_id: projectId,
                voucher_status: voucherStatus
            },
            'get',
            (response) => {

                //set data
                if (response !== null) {
                    if (response.data !== null) {
                        if (response.data.hasOwnProperty('profit_and_loss_surcharge_data')) {
                            setProfitAndLossSurchargeData(response.data.profit_and_loss_surcharge_data);
                        }
                        else {
                            //Set initial values
                            setProfitAndLossSurchargeData([]);
                        }
                    }
                }

                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
                setIsLoading(false);
            },
        );

    };

    const expandIcon = ({ expanded, onExpand, record }) => {
        if (record.hasItems && record.type === TYPE_GROUP) {
            return (
                <span style={{ marginRight: '2%' }}>
                    {expanded ? (
                        <CaretDownFilled style={{ color: "#706f71", fontSize: 12 }} onClick={(e) => onExpand(record, e)} />
                    ) : (
                        <CaretRightFilled style={{ color: "#706f71", fontSize: 12 }} onClick={(e) => onExpand(record, e)} />
                    )}
                </span>
            )
        } else {
            return <span style={{ marginRight: '3%' }}></span>
        }
    };

    const handleExpand = (record) => {
        const key = record.key;
        if (record.type === TYPE_GROUP) {
            const isExpanded = expandedRows.includes(key);
            if (record.hasItems) {
                if (isExpanded) {
                    setExpandedRows(expandedRows.filter(rowKey => rowKey !== key));
                    setBoldRows(prevBoldRows => prevBoldRows.filter(key => key !== record.key)); // Remove the key from boldRows
                } else {
                    setExpandedRows([...expandedRows, key]);
                    setBoldRows(prevBoldRows => [...prevBoldRows, record.key]);
                }
            }
        }
    };


    const exportToExcel = () => {
        setIsLoading(true);
        wtApiPostWithContentTypeHandling('reports/profit_and_loss_surcharge/export', { data: profitAndLossSurchargeData, asOf: asOf, lastYearLastDate: lastYearLastDate });
        setIsLoading(false);
    }

    const exportToPdf = async () => {
        setIsLoading(true);
        try {
            // Simulate a delay to mimic PDF generation
            await new Promise(resolve => setTimeout(resolve, 2000));
            Pdf(profitAndLossSurchargeData, asOf, lastYearLastDate);
        } catch (error) {
            console.error("Failed to generate PDF", error);
        }
        setIsLoading(false);
    };


    return (
        <div className='container-fluid' style={{
            padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica",
        }}>
            <Form
                layout={'vertical'}
                form={form}
                onFinish={getReportData}
                style={{ maxWidth: "100%", margin: '0 auto' }}
            >
                <Card title={<span style={{ fontSize: '22px', marginLeft: "35%" }}>{companyName + " Surcharge Report"}</span>} style={{ width: "100%" }}>

                    <div style={{ overflow: 'auto', margin: "auto", width: "80%" }}>
                        {Base.hasRights('Export Pdf Profit And Loss Surcharge') &&
                            <Button style={{ marginBottom: 10, float: "right", backgroundColor: "#FF0000", color: "#fff" }} onClick={exportToPdf} disabled={isLoading ? true : false} icon={<FilePdfOutlined />}></Button>
                        }
                        {Base.hasRights('Export Profit And Loss Surcharge') &&
                            <Button style={{ marginBottom: 10, float: "right", backgroundColor: "#28A745", color: "#fff" }} onClick={exportToExcel} disabled={isLoading ? true : false} icon={<FileExcelOutlined />}></Button>
                        }
                        {/* <Button style={{ marginBottom: 10, float: "right", backgroundColor: "#4BB543", color: "#fff" }} onClick={exportToExcel} disabled={isLoading ? true : false}>Export</Button> */}
                        <Table
                            columns={profitAndLossHeaderColumns}
                            dataSource={profitAndLossSurchargeData}
                            pagination={false}
                            expandable={{ expandedRowKeys: expandedRows, expandIcon: expandIcon }}
                            scroll={{ x: 'max-content' }}
                            bordered
                            size="small"
                            loading={{ indicator: <div><Spin /></div>, spinning: isLoading }}
                        />
                    </div>
                </Card>
            </Form >
        </div >
    );
};

export default ProfitAndLossSurcharge;
